import { render, staticRenderFns } from "./task-batch-action.vue?vue&type=template&id=a37ecc7c&scoped=true&"
import script from "./task-batch-action.vue?vue&type=script&lang=js&"
export * from "./task-batch-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37ecc7c",
  null
  
)

export default component.exports